/**
 * The Source object that holds the name of an article source.
 */
export class Source {

	public id:              number;     // The ID of the source in the Angular ReST API.
	public name:            string;     // The source's name. ("ESPN - Adam Schefter")


	constructor( values: Object = {} ) {
		Object.assign( this, values );
	}

}



// WEBPACK FOOTER //
// ./src/app/services/source/source.ts